import React, { useEffect } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import AnimatedSection from '../../components/AnimatedSection';
import './LegalPages.css';

function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="terms-page">
      <Navbar />
      <AnimatedSection animationType="fade-in">
        <div className="terms-container">
          <div className="terms-content">
            <h1>Legal Notice</h1>
            <p><em>Last updated: July 25, 2025</em></p>

            <h2>Article 1: Publisher Identification</h2>
            <p>The WeSplit mobile application and online service are published by the company Third Space.</p>

            <table>
              <tbody>
                <tr>
                  <td><strong>Company Name</strong></td>
                  <td>Third Space</td>
                </tr>
                <tr>
                  <td><strong>Legal Form</strong></td>
                  <td>Simplified Share Business (SAS, Société par Actions Simplifiée)</td>
                </tr>
                <tr>
                  <td><strong>Share Capital</strong></td>
                  <td>1 000 €</td>
                </tr>
                <tr>
                  <td><strong>Registered Office</strong></td>
                  <td>198 D ROUTE DE NEUVILLE, 01390 SAINT-ANDRE-DE-CORCY, France</td>
                </tr>
                <tr>
                  <td><strong>Registration</strong></td>
                  <td>Registered with the Bourg-en-bresse Trade and Companies Register (RCS) under the SIREN number: 930682703</td>
                </tr>
                <tr>
                  <td><strong>Intra-Community VAT Number</strong></td>
                  <td>FR24930682703</td>
                </tr>
                <tr>
                  <td><strong>Publication Director</strong></td>
                  <td>Ms. Pauline Mila-Alonso, in her capacity as President</td>
                </tr>
                <tr>
                  <td><strong>Contact</strong></td>
                  <td>For any questions or requests for information regarding the service, or to report any illegal content or activities, the user may contact the publisher:<br />Email address: <code>contact@wesplit.io</code></td>
                </tr>
              </tbody>
            </table>

            <h2>Article 2: Service Host</h2>
            <p>The WeSplit service and its data are hosted by:</p>
            <blockquote>
              <p><strong>Host Name:</strong> Firebase / Google<br />
              <strong>Address:</strong> 1600 Amphitheatre Parkway, Mountain View, CA 94043, United States</p>
            </blockquote>

            <h2>Article 3: Access to the Service</h2>
            <p>The service is accessible free of charge to any user with an internet connection. The publisher endeavors to allow access to the service 24 hours a day, 7 days a week, except in cases of <em>force majeure</em> or an event beyond the publisher's control, and subject to any breakdowns and maintenance interventions necessary for the proper functioning of the service.</p>

            <h2>Article 4: Intellectual Property</h2>
            <p>All elements constituting the WeSplit service (including trademarks, logos, domain names, texts, graphics, interfaces, source code, and general architecture) are the exclusive property of Third Space.</p>
            <blockquote>
              <p>Any reproduction, representation, modification, publication, or adaptation of all or part of the elements of the service, by any means or process whatsoever, is prohibited without the prior written authorization of Third Space.</p>
            </blockquote>
            <p>Any unauthorized use of the service or any of the elements it contains will be considered as constituting an infringement and will be prosecuted in accordance with the provisions of Articles L.335-2 et seq. of the French Intellectual Property Code.</p>

            <h2>Article 5: Personal Data</h2>
            <p>Third Space, in its capacity as data controller, undertakes to comply with the provisions of Regulation (EU) 2016/679 of April 27, 2016, on the protection of personal data (GDPR).</p>
            <p>Information relating to the collection and processing of personal data (purposes, legal basis, recipients, retention period, users' rights) is detailed in the service's Privacy Policy, which is directly accessible from the application.</p>
            <p>Users are reminded that they have a right of access, rectification, objection, erasure, and restriction of processing of their personal data, under the conditions and limits provided for by the regulations.</p>

            <h2>Article 6: Applicable Law and Competent Jurisdiction</h2>
            <p>This legal notice is subject to French law. In the event of a dispute and in the absence of an amicable agreement, the dispute will be brought before the competent courts of Lyon, notwithstanding multiple defendants or third-party claims.</p>
          </div>
        </div>
      </AnimatedSection>
      <Footer />
    </div>
  );
}

export default Terms;
